import { styled } from "styled-components";

export const ProductCardWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  transition: var(--transition);
  border-radius: var(--radius-md);
  background: var(--lighter);
  border: 1.5px solid var(--ice);
  overflow: hidden;

  &:hover {
    transform: translateY(-8px);
    box-shadow: var(--shadow-medium);
    border-color: var(--light);
  }

  @media only screen and (max-width: 1000px) {
    .btn {
      padding: 0.6rem 1.2rem;
      margin: 0 auto;
    }
  }
`;

export const ProductCardImgWrapper = styled.div`
  position: relative;
  background: var(--ice);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  height: 280px;
  padding: 1.5rem;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    transition: var(--transition);
    z-index: 1;
  }
  
  &:hover img {
    transform: scale(1.08);
  }

  .gta_arrow {
    padding: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--grey1);
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    transition: var(--transition);

    &:hover {
      background: white;
      transform: translateY(-50%) scale(1.1);
    }

    span {
      font-size: 20px;
    }

    &.arrow_prev {
      left: 0.5rem;
    }

    &.arrow_next {
      right: 0.5rem;
    }
  }

  .pagination {
    display: flex;
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 5;
    gap: 6px;

    .gta_page {
      width: 12px;
      height: 4px;
      background: var(--grey6);
      border-radius: 2px;
      padding: 0;
      transition: var(--transition);
      opacity: 0.5;

      &.is-active {
        width: 20px;
        background: var(--blue2);
        opacity: 1;
      }
    }
  }

  div.placeholder {
    height: 210px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    max-width: 140px;
    margin: auto;

    span {
      display: block;
      color: var(--lead);
      font-size: 36px;
      margin-bottom: 0.5rem;
    }
  }

  .gta_arrow {
    padding: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    span {
      display: block;
    }

    &.arrow_prev {
      left: 0.5rem;
    }

    &.arrow_next {
      right: 0.5rem;
    }
  }

  .pagination {
    display: flex;
    max-width: 50%;
    margin: auto;

    & > *:not(:last-child) {
      margin-right: 1rem;
    }
  }
`;

export const ProductCardTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 1.5rem;

  p {
    &.title {
      font-size: 1.25rem;
      font-weight: 700;
      line-height: 1.3;
      color: var(--dark);
      margin-bottom: 0.75rem;
      height: 3.2rem;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    &.description {
      font-size: 0.9rem;
      line-height: 1.5;
      color: var(--grey3);
      margin-bottom: 0.5rem;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    &.dimensions {
      font-size: 0.85rem;
      font-weight: 600;
      color: var(--grey4);
      margin-bottom: 1.5rem;
      display: flex;
      align-items: center;
      gap: 0.4rem;
      
      &::before {
        content: 'straighten';
        font-family: 'Material Symbols Rounded';
        font-size: 16px;
      }
    }

    &.price {
      font-size: 1.5rem;
      font-weight: 800;
      color: var(--blue);
      margin-top: auto;
      margin-bottom: 1rem;
    }
  }

  a.details-link {
    font-size: 1rem;
    font-weight: 600;
    color: var(--lead);
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: var(--transition);

    &::after {
      content: '→';
      transition: transform 0.2s;
    }

    &:hover {
      color: var(--blue2);
      &::after {
        transform: translateX(4px);
      }
    }
  }
`;

export const ProductCardTypeWrapper = styled.div`
  background: rgba(39, 55, 130, 0.8);
  color: var(--lighter);
  font-size: 14px;
  line-height: 17.77px;
  border-radius: 5px;
  padding: 0.5rem 1rem;
  width: fit-content;
  position: absolute;
  top: 1rem;
  right: 0.75rem;
`;
